import Icon from "./IconBase.js";

const CrossIcon = (props) => (
  <Icon width="22" height="22" viewBox="0 0 24 24" {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#0F0F0F"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="#0F0F0F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#0F0F0F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export default CrossIcon;
